import type { DateFormatOptions } from '../interfaces/Locale';
import { enUSLocale } from './dateFnLocales';

/**
 * The locales are exported as mutable exports:
 * 1) To avoid using a react context for components deep in the tree
 * 2) It's more similar to how ttag works
 */
export let dateLocale = enUSLocale;
export let defaultDateLocale = enUSLocale;
export let browserDateLocale = enUSLocale;
export let dateLocaleCode = 'en_US';
export let browserLocaleCode = 'en_US';
export let localeCode = 'en_US';
export let languageCode = 'en';
export let dateFormatOptions: DateFormatOptions | undefined;

export type LocaleChangeSubscriber = (locale: { localeCode: string; languageCode: string }) => void;
const localeChangeSubscribers = new Set<LocaleChangeSubscriber>();

export function subscribeToLocaleChange(subscriber: LocaleChangeSubscriber) {
    localeChangeSubscribers.add(subscriber);
    return function unsubscribe() {
        localeChangeSubscribers.delete(subscriber);
    };
}

export const setLocales = ({
    localeCode: newLocaleCode = localeCode,
    languageCode: newLanguageCode = languageCode,
}) => {
    localeCode = newLocaleCode;
    languageCode = newLanguageCode;
    for (const subscriber of localeChangeSubscribers) {
        subscriber({ localeCode, languageCode });
    }
};

export const setDateLocales = ({
    defaultDateLocale: newDefaultDateLocale = defaultDateLocale,
    browserDateLocale: newBrowserDateLocale = browserDateLocale,
    browserLocaleCode: newBrowserLocaleCode = browserLocaleCode,
    dateLocale: newDateLocale = dateLocale,
    dateLocaleCode: newDateLocaleCode = dateLocaleCode,
    dateFormatOptions: newDateFormatOptions = dateFormatOptions,
}) => {
    defaultDateLocale = newDefaultDateLocale;
    browserDateLocale = newBrowserDateLocale;
    browserLocaleCode = newBrowserLocaleCode;
    dateLocale = newDateLocale;
    dateLocaleCode = newDateLocaleCode;
    dateFormatOptions = newDateFormatOptions;
};
